export const ACTION_GET_CATEGORIES_BENEFITS = "ACTION_GET_CATEGORIES_BENEFITS";
export const ACTION_GET_CATEGORIES = "ACTION_GET_CATEGORIES";
export const ACTION_GET_CATEGORY_TYPE = "ACTION_GET_CATEGORY_TYPE";
export const ACTION_GET_SUBCATEGORIES = "ACTION_GET_SUBCATEGORIES";
export const ACTION_GET_MODE = "ACTION_GET_MODE";
export const ACTION_POST_CREATE_CATEGORIES = 'ACTION_POST_CREATE_CATEGORIES';
export const ACTION_PUT_UPDATE_CATEGORIES = 'ACTION_PUT_UPDATE_CATEGORIES';  
export const ACTION_DELETE_DELETE_CATEGORIES = 'ACTION_DELETE_DELETE_CATEGORIES';
export const ACTION_POST_CREATE_SUBCATEGORIES = 'ACTION_POST_CREATE_SUBCATEGORIES';
export const ACTION_PUT_UPDATE_SUBCATEGORIES = 'ACTION_PUT_UPDATE_SUBCATEGORIES';
export const ACTION_DELETE_DELETE_SUBCATEGORIES = 'ACTION_DELETE_DELETE_SUBCATEGORIES';
export const ACTION_GET_CATEGORIES_ID = "ACTION_GET_CATEGORIES_ID";
